import React, { useMemo } from 'react';
import * as PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cn from 'classnames';

import Icon from '../../../Icon';
import ClickableElement from '../../../ClickableElement';
import { useVirtualVisit } from '../../../../redux/opentok/hooks/useVirtualVisit';

import styles from './styles.styl';

function MembersSidebar({ intl: { formatMessage }, children, count }) {
  const { viewOptions } = useVirtualVisit();
  const { mobSidebarOpened, toggleMobSidebar } = viewOptions;

  const title = useMemo(() => {
    const i18n = formatMessage({ id: 'virtualVisit.room.callMembers' });
    return `${i18n} (${count || '-'})`;
  }, [count]);

  return (
    <div className={cn(styles.root, { [styles.mobOpened]: mobSidebarOpened })}>
      <ClickableElement onClick={toggleMobSidebar} className={styles.closeBtn}>
        <Icon name="close" size={18} />
      </ClickableElement>
      <div className={styles.head}>{title}</div>
      <div className={styles.content}>{children}</div>
    </div>
  );
}

MembersSidebar.propTypes = {
  children: PropTypes.node,
  count: PropTypes.number,
  intl: PropTypes.object,
};

export default injectIntl(MembersSidebar);



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/MembersSidebar/index.jsx